/**
 * @param {{
 *   value: number;
 *   min?: number;
 *   max?: number;
 *   step?: number | string;
 *   onChange: (event: import('react').ChangeEvent<HTMLInputElement>) => void;
 *   onInput?: (event: import('react').FormEvent<HTMLInputElement>) => void;
 *   'aria-label'?: string;
 *   id?: string;
 *   className?: string;
 *   disabled?: boolean;
 * }} props
 */
function StyledRangeSlider({
  value,
  min = 0,
  max = 100,
  step = 1,
  onChange,
  onInput,
  'aria-label': ariaLabel,
  id,
  className = '',
  disabled = false,
}) {
  const range = max - min;
  const sliderProgress = range > 0 ? ((value - min) / range) * 100 : 0;

  return (
    <input
      type="range"
      id={id}
      className={`standard-range-slider${className ? ` ${className}` : ''}`}
      min={min}
      max={max}
      step={step}
      value={value}
      disabled={disabled}
      aria-label={ariaLabel}
      onChange={onChange}
      onInput={onInput}
      style={{
        '--slider-progress': `${sliderProgress}%`,
      }}
    />
  );
}

export default StyledRangeSlider;
